"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { isFeatureVisible, useTenantFeatures } from "./TenantProvider";

// Route guard modul ber-feature-flag per tenant.
// features null (belum diketahui — mode GWA/dev) → render children;
// flag false → redirect ke /dashboard (menu-nya memang tidak tampil).
export default function FeatureGuard({
  feature,
  children,
}: {
  feature: string;
  children: React.ReactNode;
}) {
  const features = useTenantFeatures();
  const router = useRouter();
  const visible = isFeatureVisible(features, feature);

  useEffect(() => {
    if (!visible) router.replace("/dashboard");
  }, [visible, router]);

  if (!visible) return null;
  return <>{children}</>;
}
